var map = {
	"./1.png": 9633,
	"./10.png": 7082,
	"./2.png": 6568,
	"./3.png": 4439,
	"./4.png": 2532,
	"./5.png": 1436,
	"./6.png": 2048,
	"./7.png": 7544,
	"./8.png": 6622,
	"./9.png": 1304,
	"./anchor_icon.png": 8482,
	"./author_icon.png": 1189
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5995;